import { useMemo } from "react";
import { Column, useTable } from "react-table";
import { DefinitionList, DefinitionListItem } from "@funcional/react-ui";
import {
  IRegistrationPolicy,
  IFormField,
} from "@pbm/registration-policies/contracts";
import { IntlDateTime, IntlEnum } from "@funcional/react-intl-ui";
import { ReactTable } from "@funcional/react-table-ui";

export function RegistrationPolicyCard({
  registrationPolicy,
}: {
  registrationPolicy: IRegistrationPolicy;
}) {
  const columns: Column<IFormField>[] = useMemo(
    () =>
      [
        { Header: "Código", accessor: "code" },
        { Header: "Rótulo", accessor: "label" },
        {
          Header: "Tipo",
          accessor: "type",
          Cell: ({ value }) => <IntlEnum name="field_type" value={value} />,
        },
        {
          Header: "Preenchimento",
          accessor: "display",
          Cell: ({ value }) => <IntlEnum name="field_display" value={value} />,
        },
        { Header: "Descrição", accessor: "description" },
        { Header: "Valor Padrão", accessor: "defaultValue" },
        {
          Header: "Entidade",
          accessor: "entityField",
          Cell: ({ value }) => <IntlEnum name="entity_field" value={value} />,
        },
        {
          Header: "Opções",
          accessor: "options",
          Cell: ({ value }: { value: any[] }) => value.length,
        },
        { Header: "API Externa", accessor: "externalApiField" },
      ] as Column<IFormField>[],
    []
  );

  const tableInstance = useTable({
    columns,
    data: registrationPolicy.formFields || [],
  });

  return (
    <>
      <DefinitionList className="mb-8">
        <DefinitionListItem label="Política">
          {registrationPolicy.description}
        </DefinitionListItem>
        <DefinitionListItem label="Exige cadastro?">
          {registrationPolicy.requiresRegistration ? "Sim" : "Não"}
        </DefinitionListItem>
        <DefinitionListItem label="Exige receita?">
          {registrationPolicy.requiresPrescription ? "Sim" : "Não"}
        </DefinitionListItem>
        <DefinitionListItem label="Exige Contato?">
          {registrationPolicy.requiresContactInformation ? "Sim" : "Não"}
        </DefinitionListItem>
        <DefinitionListItem label="Consulta Api Externa?">
          {registrationPolicy.enabledApiExternal ? "Sim" : "Não"}
        </DefinitionListItem>
        <DefinitionListItem label="Criada em">
          <IntlDateTime value={registrationPolicy.createdAt} />
        </DefinitionListItem>
        <DefinitionListItem label="Atualizada em">
          <IntlDateTime value={registrationPolicy.updatedAt} />
        </DefinitionListItem>
        {registrationPolicy.deletedAt ? (
          <DefinitionListItem label="Excluída em">
            <IntlDateTime value={registrationPolicy.deletedAt} />
          </DefinitionListItem>
        ) : null}
        <DefinitionListItem label="Origens permitidas">
          <ul>
            {(registrationPolicy.allowedOrigins || []).map((value) => (
              <li key={value} title={value}>
                <IntlEnum name="authorization_origin" value={value} />
              </li>
            ))}
          </ul>
        </DefinitionListItem>
      </DefinitionList>

      <ReactTable tableInstance={tableInstance} />
    </>
  );
}
